import React from "react";

import ApplicantDetailsForm from "./steps/ApplicantDetails";
import ApplicantEmploymentForm from "./steps/ApplicantEmployment";
import ExpenditureForm from "./steps/Expenditure";
import BrokerDetailsForm from "./steps/BrokerDetails";
import LoanForm from "./steps/Loan";
import OtherDetailsForm from "./steps/OtherDetails";
import PropertyForm from "./steps/Property";
import ProductForm from "./steps/Product";
import ReviewConfirmForm from "./steps/ReviewConfirm";

import { APP_URLS } from "settings";
import parseDataForApiApplicantDetails from "./steps/ApplicantDetails/api";
import parseDataForApiApplicantEmployment from "./steps/ApplicantEmployment/api";
import parseDataForApiExpenditure from "./steps/Expenditure/api";
import parseDataForApiBroker from "./steps/BrokerDetails/api";
import parseDataForApiLoan from "./steps/Loan/api";
import parseDataForApiOther from "./steps/OtherDetails/api";
import parseDataForApiProperty from "./steps/Property/api";
import parseDataForApiProduct from "./steps/Product/api";
import parseDataForApiReviewConfirm from "./steps/ReviewConfirm/api";

export type StepType = {
  id: number;
  key:
    | "broker"
    | "applicants"
    | "employments"
    | "expenditure"
    | "loan"
    | "property"
    | "other"
    | "product"
    | "confirm";
  name: string;
  component: React.FC<any>;
  parser: Function;
};

export const DEFAULT_STEP: { id: number; key: string } = {
  id: 1,
  key: "broker",
};

export const STEPS: { [k: number]: StepType } = {
  1: {
    id: 1,
    key: "broker",
    name: "Broker",
    component: BrokerDetailsForm,
    parser: parseDataForApiBroker,
  },
  2: {
    id: 2,
    key: "applicants",
    name: "Applicant",
    component: ApplicantDetailsForm,
    parser: parseDataForApiApplicantDetails,
  },
  3: {
    id: 3,
    key: "property",
    name: "Property",
    component: PropertyForm,
    parser: parseDataForApiProperty,
  },
  4: {
    id: 4,
    key: "loan",
    name: "Loan",
    component: LoanForm,
    parser: parseDataForApiLoan,
  },
  5: {
    id: 5,
    key: "employments",
    name: "Employment",
    component: ApplicantEmploymentForm,
    parser: parseDataForApiApplicantEmployment,
  },
  6: {
    id: 6,
    key: "expenditure",
    name: "Expenditure",
    component: ExpenditureForm,
    parser: parseDataForApiExpenditure,
  },
  7: {
    id: 7,
    key: "other",
    name: "Other Details",
    component: OtherDetailsForm,
    parser: parseDataForApiOther,
  },
  8: {
    id: 8,
    key: "product",
    name: "Product",
    component: ProductForm,
    parser: parseDataForApiProduct,
  },
  9: {
    id: 9,
    key: "confirm",
    name: "Review & Confirm",
    component: ReviewConfirmForm,
    parser: parseDataForApiReviewConfirm,
  },
};

export const TOTAL_STEPS = Object.keys(STEPS).length;

export const getStepByKey = (stepKey: string): StepType =>
  Object.values(STEPS).find((step) => step.key === stepKey) ||
  STEPS[DEFAULT_STEP.id];

export const getStepByID = (stepID: number): StepType =>
  Object.values(STEPS).find((step) => step.id === stepID) ||
  STEPS[DEFAULT_STEP.id];

export const applicationStepOne = (applicationID: string | null = null) => {
  const stepOne = STEPS[1];
  if (applicationID) {
    return `${APP_URLS.APPLICATION_FORM}/${applicationID}/${stepOne.key}`;
  }
  return `${APP_URLS.APPLICATION_FORM}/${stepOne.key}`;
};
